import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import TotpEnrollmentForm from './security/TotpEnrollmentForm';

// Gate bloqueante análogo a OnboardingDialog.js: se muestra cuando la cuenta
// del usuario exige MFA (security.mfa_required, ver LayoutApp.js) y el
// usuario todavía no tiene TOTP activo. No se puede cerrar por backdrop/Esc
// -- solo completando el enrolamiento (onEnrolled -> Cognito desafiará a
// este usuario con MFA en cada login futuro, sin lógica adicional).
const MfaSetupDialog = ({ open, onEnrolled }) => {
  const handleCloseRequest = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={handleCloseRequest}
      PaperProps={{
        sx: {
          backgroundColor: 'var(--wb-bg-deep)',
          border: '1px solid var(--wb-orange)',
          borderRadius: 4,
          color: 'var(--wb-text-strong)',
          width: '100%',
          maxWidth: 480
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: 'var(--wb-text-strong)' }}>
            Configura tu verificación en dos pasos
          </Typography>
          <Typography variant="body2" sx={{ color: 'var(--wb-orange)', mt: 1 }}>
            Tu cuenta requiere MFA para continuar
          </Typography>
          <Box
            sx={{
              height: 4,
              width: 64,
              backgroundColor: 'var(--wb-orange)',
              borderRadius: 2,
              mt: 2,
              mx: 'auto'
            }}
          />
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 3 }}>
        <TotpEnrollmentForm onEnrolled={onEnrolled} />
      </DialogContent>
    </Dialog>
  );
};

export default MfaSetupDialog;
